/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateStatus } from './FormulaEvaluateStatus';
import {
    FormulaEvaluateStatusFromJSON,
    FormulaEvaluateStatusFromJSONTyped,
    FormulaEvaluateStatusToJSON,
    FormulaEvaluateStatusToJSONTyped,
} from './FormulaEvaluateStatus';

/**
 * 
 * @export
 * @interface FormulaEvaluateDebugExecutionProfile
 */
export interface FormulaEvaluateDebugExecutionProfile {
    /**
     * 
     */
    step: string;
    /**
     * 
     */
    status: FormulaEvaluateStatus;
    /**
     * 
     */
    durationMs: number;
}



/**
 * Check if a given object implements the FormulaEvaluateDebugExecutionProfile interface.
 */
export function instanceOfFormulaEvaluateDebugExecutionProfile(value: object): value is FormulaEvaluateDebugExecutionProfile {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('durationMs' in value) || value['durationMs'] === undefined) return false;
    return true;
}

export function FormulaEvaluateDebugExecutionProfileFromJSON(json: any): FormulaEvaluateDebugExecutionProfile {
    return FormulaEvaluateDebugExecutionProfileFromJSONTyped(json, false);
}

export function FormulaEvaluateDebugExecutionProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateDebugExecutionProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'],
        'status': FormulaEvaluateStatusFromJSON(json['status']),
        'durationMs': json['durationMs'],
    };
}

export function FormulaEvaluateDebugExecutionProfileToJSON(json: any): FormulaEvaluateDebugExecutionProfile {
    return FormulaEvaluateDebugExecutionProfileToJSONTyped(json, false);
}

export function FormulaEvaluateDebugExecutionProfileToJSONTyped(value?: FormulaEvaluateDebugExecutionProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'step': value['step'],
        'status': FormulaEvaluateStatusToJSON(value['status']),
        'durationMs': value['durationMs'],
    };
}

